import React from "react";
//outsource
import { Row, Col, Card, Button, Tooltip, Badge } from "antd";
import InputIncome from "./input_income";
import lodash from "lodash";
import { PlusOutlined } from "@ant-design/icons";
//components

const CardStaff = ({
  data,
  order,
  edit,
  maxIncome,
  // removeRow,
  handleAdd,
  handleChange,
  handleDeleteIncome,
  loading,
}) => {
  // -------------------------- VAR --------------------------
  const userId = data?.userId;
  const fullName = data?.fullName;
  const index = order + 1;
  const income = data?.income || [];

  const total = lodash.sumBy(income, (r) => r?.value) || 0;
  const max = maxIncome === total ? true : false;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER -------------------------
  // const renderFillIncome = () => {
  //   return (
  //       {renderCardFill()}
  //   );
  // };

  const renderCardFill = () => {
    const sortedIncome = lodash.sortBy(income, ["createAt"]);
    return (
      <Row gutter={[10, 10]}>
        {sortedIncome?.map((item, index) => {
          return (
            <Col key={index} span={4}>
              <InputIncome
                edit={edit}
                userId={userId}
                data={item}
                index={index}
                handleChange={handleChange}
                handleDeleteIncome={handleDeleteIncome}
                // loading={loading}
              />
            </Col>
          );
        })}
        <Col span={4}> {renderButton()}</Col>
      </Row>
    );
  };

  const renderButton = () => {
    return (
      <Button
        type="dashed"
        disabled={!edit}
        loading={loading}
        onClick={() => handleAdd(userId)}
        icon={<PlusOutlined />}
        block
      />
    );
  };

  const renderCard = () => {
    return (
      <Card
        className="card-staff-body"
        bodyStyle={{
          width: "100%",
          borderRadius: 10,
        }}
        key={userId}
      >
        <Col span={24}>
          <Row align="middle" gutter={[20, 20]}>
            <Col span={6} align="left">
              <strong>
                {index}. {fullName}
              </strong>
            </Col>
            <Col span={16}>{renderCardFill()}</Col>
            <Col align="right" span={2}>
              <strong>$ {total}</strong>
            </Col>
          </Row>
        </Col>
      </Card>
    );
  };

  // -------------------------- MAIN --------------------------
  if (max) {
    return (
      <Badge.Ribbon placement="start" text="Winner" color="pink">
        {renderCard()}
      </Badge.Ribbon>
    );
  }

  return renderCard();
};

export default CardStaff;
